import { Helmet } from "react-helmet-async";

const MetaTags = ({ title, description, keywords, noIndex = false }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noIndex && (
        <>
          <meta name="robots" content="noindex, nofollow" />
          <meta name="googlebot" content="noindex, nofollow" />
        </>
      )}
    </Helmet>
  );
};

export default MetaTags;
